const environment = {
  apiUrl: "https://api.blueskyglobal.io/api",
  // apiUrl: "http://127.0.0.1:5000/api", 
  apiKey: "2b0f81a5-6c39-4d89-a6f2-978a1c4b9c0f39a2ed7b-4a3c-4f89-84d1-7e62e4a8d937"
};

export default environment;